// extracted by mini-css-extract-plugin
var _1 = "awmsABJh";
var _2 = "NuyLfplD";
var _3 = "awmsABJh";
var _4 = "NuyLfplD";
export { _1 as "icon-review", _2 as "icon-review-list", _3 as "iconReview", _4 as "iconReviewList" }
